/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import RegisterAction from './RegisterAction/index'
import SaveAction from './SaveAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsurancePlan/Content/Content/Confirm/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Edit insurance plan"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 alignItems="center"
 gap={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Are you sure you want to edit this insurance plan?"
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Please, consider registering a New Plan instead."
 color={dtColorsNeutral600}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<RegisterAction
{...childProps}
  viewPath={`${viewPath}/RegisterAction`}
/>
<SaveAction
{...childProps}
  viewPath={`${viewPath}/SaveAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}